import { useEffect, useState } from "react";
import { Camera } from "lucide-react";
import { api } from "../lib/api";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/gallery")
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="no-img-drag">
      <section className="bg-soft-cream">
        <div className="max-w-7xl mx-auto container-x py-16">
          <p className="text-brand-red font-semibold text-xs uppercase tracking-[0.2em] mb-3">Galerie</p>
          <h1 className="font-display font-extrabold text-brand-navy text-4xl sm:text-5xl lg:text-6xl tracking-tight">Cabinetul Ro-Dental</h1>
          <p className="mt-5 text-brand-navy/75 text-lg max-w-2xl font-light">Imagini din interiorul cabinetului — un spațiu gândit pentru confortul și liniștea pacienților noștri.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto container-x py-14">
        {loading ? (
          <div className="text-center text-brand-navy/60 py-20">Se încarcă…</div>
        ) : !items.length ? (
          <div className="bg-white rounded-3xl p-12 sm:p-16 border border-brand-beige text-center max-w-2xl mx-auto" data-testid="gallery-empty-state">
            <div className="mx-auto w-16 h-16 rounded-full bg-brand-yellow/30 flex items-center justify-center text-brand-navy">
              <Camera className="w-8 h-8" />
            </div>
            <h2 className="mt-6 font-display font-bold text-brand-navy text-2xl">Galeria este în pregătire</h2>
            <p className="mt-4 text-brand-navy/70 leading-relaxed">
              Vom adăuga în curând imagini din interiorul cabinetului. Vă invităm să reveniți pentru a descoperi atmosfera caldă a cabinetului Ro-Dental.
            </p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="gallery-grid">
            {items.map((it, idx) => (
              <figure key={it.id || idx} className="rounded-3xl overflow-hidden shadow-soft bg-white group">
                <div className="aspect-[4/3] overflow-hidden bg-brand-cream">
                  <img
                    src={it.image_url}
                    alt={it.caption || "Galerie Ro-Dental"}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    draggable={false}
                    onContextMenu={(e) => e.preventDefault()}
                  />
                </div>
                {it.caption && (
                  <figcaption className="p-4 text-sm text-brand-navy/80 font-medium">{it.caption}</figcaption>
                )}
              </figure>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
